const encoder = new TextEncoder();

// StringTableBuilder stores unique strings in one null-terminated byte table.
// Offset 0 is reserved for missing values via the initial sentinel byte.
export class StringTableBuilder {
  private offsets = new Map<string, number>();
  private chunks: Uint8Array[] = [new Uint8Array([0])];
  private length = 1;

  add(value?: string): number {
    if (!value) {
      return 0;
    }

    const cachedOffset = this.offsets.get(value);
    if (cachedOffset !== undefined) {
      return cachedOffset;
    }

    const offset = this.length;
    const encoded = encoder.encode(value);
    const chunk = new Uint8Array(encoded.length + 1);
    chunk.set(encoded, 0);
    this.chunks.push(chunk);
    this.offsets.set(value, offset);
    this.length += chunk.length;
    return offset;
  }

  toUint8Array(): Uint8Array {
    const bytes = new Uint8Array(this.length);
    let cursor = 0;
    for (const chunk of this.chunks) {
      bytes.set(chunk, cursor);
      cursor += chunk.length;
    }
    return bytes;
  }
}

export function readNullTerminatedString(
  decoder: TextDecoder,
  bytes: Uint8Array,
  start: number,
  end: number,
  cache: Map<number, string>,
): string | undefined {
  if (start === 0) {
    return undefined;
  }
  const cached = cache.get(start);
  if (cached !== undefined) {
    return cached;
  }

  let cursor = start;
  while (cursor < end && bytes[cursor] !== 0) {
    cursor += 1;
  }

  const value = decoder.decode(bytes.subarray(start, cursor));
  cache.set(start, value);
  return value;
}
